import { useTranslations } from './useTranslations'

export function useT() {
  const { translations } = useTranslations()

  return (key: string) => translations[key]?.message || key
}
